import axios from 'axios';
import { rmaFilterApiUrl } from '@/GlobalConfig/app-config';

class RmaFilterService{
    constructor(){}

    public async getFilteredData(saveData: any){
        const url = rmaFilterApiUrl;
        let token = localStorage.getItem("token");
        return axios({
            method: 'post',
            url: url,
            data: saveData,
            headers: {"Authorization":"Token " + token}
        });
    }
}

export const rmaFilterService = new RmaFilterService();